import { Link } from '@tanstack/react-router'
import { Check } from 'lucide-react'
import { AnimatePresence, motion } from 'motion/react'
import { useState } from 'react'
import { SonCta } from '../components/cta'
import { Reveal, Stagger, StaggerItem } from '../components/hareket'
import { SssAkordeon } from '../components/sss-akordeon'
import { Baslik, ButonLink, DEMO_YOLU, Kart, Rozet, SayfaUstu, Section, cn } from '../components/ui'
import { modulBul } from '../icerik/moduller'
import { DENEME, PAKETLER, PLANLAR, tl } from '../icerik/planlar'
import { useHead } from '../lib/head'

export function Fiyatlandirma() {
  useHead(
    {
      title: 'Fiyatlandırma',
      description:
        'Başlangıç, Standart, Pro ve Kurumsal planlar; Etkinlik, Akademi ve Mağaza paketleri. On dört gün deneme, kart bilgisi yok, yıllık ödemede iki ay hediye.',
    },
    '/fiyatlandirma',
  )
  const [yillik, setYillik] = useState(true)
  return (
    <>
      <SayfaUstu>
        <Section className="pt-0 sm:pt-0">
          <Reveal>
            <Baslik
              seviye="h1"
              eyebrow="Fiyatlandırma"
              baslik="Açık fiyat, açık sınır"
              metin="Ücretsiz plan yok; on dört gün deneme var. Üye portalı ve online ödeme her planda dahil, eklenti değil. Tahsilattan komisyon almayız. Fiyatlar KDV hariçtir."
              hizala="center"
            />
          </Reveal>
          <Reveal delay={0.1} className="mt-8 flex justify-center">
            <div
              className="relative inline-flex rounded-full bg-subtle p-1 ring-1 ring-line"
              role="tablist"
              aria-label="Ödeme dönemi"
            >
              {(['Aylık', 'Yıllık'] as const).map((d) => {
                const secili = (d === 'Yıllık') === yillik
                return (
                  <button
                    key={d}
                    role="tab"
                    aria-selected={secili}
                    type="button"
                    onClick={() => setYillik(d === 'Yıllık')}
                    className={cn(
                      'relative z-10 rounded-full px-5 py-2 text-sm font-medium transition-colors',
                      secili ? 'text-on-brand' : 'text-ink-2',
                    )}
                  >
                    {secili && (
                      <motion.span
                        layoutId="donem"
                        className="absolute inset-0 -z-10 rounded-full bg-brand"
                        transition={{ type: 'spring', stiffness: 400, damping: 32 }}
                      />
                    )}
                    {d}
                    {d === 'Yıllık' && (
                      <span className={cn('ml-2 text-xs', secili ? 'opacity-80' : 'text-brand')}>
                        iki ay hediye
                      </span>
                    )}
                  </button>
                )
              })}
            </div>
          </Reveal>

          <Stagger className="mt-12 grid gap-4 lg:grid-cols-4">
            {PLANLAR.map((p) => (
              <StaggerItem key={p.kod} className="h-full">
                <Kart className={cn('flex h-full flex-col p-6', p.vurgu && 'ring-2 ring-brand')}>
                  <div className="flex items-center justify-between">
                    <p className="text-lg font-semibold text-ink">{p.ad}</p>
                    {p.vurgu && <Rozet tone="brand">Yaygın tercih</Rozet>}
                  </div>
                  <p className="mt-1 text-sm text-ink-3">{p.kimIcin}</p>
                  <div className="mt-5 h-16">
                    <AnimatePresence mode="wait" initial={false}>
                      <motion.div
                        key={yillik ? 'y' : 'a'}
                        initial={{ opacity: 0, y: 6 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -6 }}
                        transition={{ duration: 0.18 }}
                      >
                        {p.aylik ? (
                          <>
                            <p className="data text-3xl font-semibold text-ink">
                              {tl(yillik ? Math.round(p.yillik / 12) : p.aylik)}
                              <span className="text-sm font-normal text-ink-3"> / ay</span>
                            </p>
                            <p className="mt-1 text-xs text-ink-3">
                              {yillik ? `Yıllık ${tl(p.yillik)} · tek fatura` : 'Aylık faturalanır'}
                            </p>
                          </>
                        ) : (
                          <>
                            <p className="data text-3xl font-semibold text-ink">Görüşmeli</p>
                            <p className="mt-1 text-xs text-ink-3">Yapıya göre teklif</p>
                          </>
                        )}
                      </motion.div>
                    </AnimatePresence>
                  </div>
                  <ul className="mt-2 space-y-1.5 text-sm text-ink-2">
                    <li className="data">
                      {p.uye ? `${p.uye.toLocaleString('tr-TR')} üye` : 'Sınırsız üye'}
                    </li>
                    <li className="data">
                      {p.yonetici ? `${p.yonetici} yönetici` : 'Sınırsız yönetici'}
                    </li>
                    <li className="data">
                      {p.epostaAy
                        ? `${p.epostaAy.toLocaleString('tr-TR')} e-posta / ay`
                        : 'Sınırsız e-posta'}
                    </li>
                    <li className="data">
                      {p.depolamaGb ? `${p.depolamaGb} GB depolama` : 'Depolama görüşmeli'}
                    </li>
                  </ul>
                  <ul className="mt-5 space-y-2 border-t border-line pt-5 text-sm text-ink">
                    {p.ozellikler.map((o) => (
                      <li key={o} className="flex items-start gap-2">
                        <Check className="mt-0.5 size-4 shrink-0 text-brand" aria-hidden />
                        {o}
                      </li>
                    ))}
                  </ul>
                  <div className="mt-auto pt-6">
                    <ButonLink
                      to={DEMO_YOLU}
                      variant={p.vurgu ? 'primary' : 'secondary'}
                      className="w-full"
                    >
                      {p.aylik ? 'Denemeyi başlatın' : 'Görüşme isteyin'}
                    </ButonLink>
                  </div>
                </Kart>
              </StaggerItem>
            ))}
          </Stagger>
        </Section>
      </SayfaUstu>

      <Section className="bg-surface/60">
        <Reveal>
          <Baslik
            eyebrow="Paketler"
            baslik="Plana eklenir, ihtiyaç bitince kapanır"
            metin="Etkinlik ve kurs başına lisans yok, bilet başına komisyon yok. Paket aylıktır; kaç kongre açtığınız fark etmez."
          />
        </Reveal>
        <Stagger className="mt-10 grid gap-4 md:grid-cols-3">
          {PAKETLER.map((p) => {
            const m = modulBul(p.modul)
            return (
              <StaggerItem key={p.kod} className="h-full">
                <Kart className="flex h-full flex-col p-6">
                  <div className="flex items-center gap-3">
                    <span className="grid size-10 place-items-center rounded-[var(--radius-card)] bg-brand-subtle text-brand">
                      <m.ikon className="size-5" />
                    </span>
                    <p className="text-lg font-semibold text-ink">{p.ad}</p>
                  </div>
                  <p className="data mt-4 text-2xl font-semibold text-ink">
                    {tl(p.aylik)}
                    <span className="text-sm font-normal text-ink-3"> / ay</span>
                  </p>
                  <p className="mt-2 text-sm leading-relaxed text-ink-2">{p.aciklama}</p>
                  <Link
                    to={`/ozellikler/${p.modul}`}
                    className="mt-auto pt-5 text-sm font-medium text-brand hover:underline"
                  >
                    {m.ad} sayfası
                  </Link>
                </Kart>
              </StaggerItem>
            )
          })}
        </Stagger>
      </Section>

      <Section>
        <div className="grid gap-10 lg:grid-cols-2 lg:gap-16">
          <Reveal>
            <Baslik
              eyebrow="Deneme"
              baslik={`${DENEME.gun} gün, ${DENEME.uye} üyeye kadar`}
              metin="Kayıt sırasında kart istemiyoruz; derneğin yönetim kurulu üyesinin kendi kartını vermek zorunda kalması doğru değil."
            />
            <ul className="mt-6 space-y-2.5">
              {DENEME.notlar.map((n) => (
                <li key={n} className="flex items-start gap-2.5 text-[15px] text-ink">
                  <Check className="mt-0.5 size-4 shrink-0 text-brand" aria-hidden />
                  {n}
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.1}>
            <Baslik
              eyebrow="Kurulum ve geçiş"
              baslik="Standart aktarım ücretsiz"
              metin="Excel ya da CSV ile üye ve aidat listesini kendiniz aktarırsınız; ön izlemeli, hatasız satır yazılmaz. Eski bir yazılımın veritabanından taşıma ise günler süren bir iştir ve teklife bağlıdır."
            />
            <Link
              to="/gecis"
              className="mt-6 inline-flex text-sm font-medium text-brand hover:underline"
            >
              Geçiş sayfası
            </Link>
          </Reveal>
        </div>
      </Section>

      <Section className="bg-surface/60">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.6fr]">
          <Reveal>
            <Baslik eyebrow="Sık sorulanlar" baslik="Fiyat hakkında" />
          </Reveal>
          <Reveal delay={0.1}>
            <SssAkordeon
              sorular={[
                {
                  soru: 'KDV dahil mi?',
                  cevap:
                    'Hayır, fiyatlar KDV hariçtir; faturada ayrıca gösterilir. Yıllık ödemede tek fatura kesilir ve derneğin bütçe kalemine oturur.',
                },
                {
                  soru: 'Üye sınırını aşarsak ne olur?',
                  cevap:
                    'Panel sınıra yaklaşınca uyarır. Aşınca yeni üye kaydı bir üst plana geçene kadar bekler; mevcut veri ve işleyiş hiçbir zaman durmaz.',
                },
                {
                  soru: 'Plan değiştirmek kolay mı?',
                  cevap:
                    'Panelden, anında. Özellikler plan değiştiği anda açılır; fark kalan döneme göre hesaplanır.',
                },
                {
                  soru: 'SMS ücreti var mı?',
                  cevap:
                    'SMS derneğin kendi Netgsm hesabından gider; kontörü oradan alırsınız. Biz SMS satmıyoruz, ileti sorumluluğu da bizde değil derneğinizde kalıyor.',
                },
                {
                  soru: 'Tahsilattan pay alıyor musunuz?',
                  cevap:
                    'Hayır. Ödeme sağlayıcısının kendi komisyonu dışında bir kesinti yoktur; para doğrudan derneğin hesabına geçer.',
                },
                {
                  soru: 'Mali müşavir ya da federasyon için indirim var mı?',
                  cevap:
                    'Birden çok derneği yöneten mali müşavirler ve üye derneklerini toplu getiren federasyonlar için ayrı bir program hazırlıyoruz; görüşelim.',
                },
              ]}
            />
          </Reveal>
        </div>
      </Section>
      <SonCta />
    </>
  )
}
